import { render, staticRenderFns } from "./security-setting-inner-bv.vue?vue&type=template&id=5b30e715&"
import script from "./security-setting-inner-bv.vue?vue&type=script&lang=js&"
export * from "./security-setting-inner-bv.vue?vue&type=script&lang=js&"
import style0 from "./security-setting-inner-bv.vue?vue&type=style&index=0&id=5b30e715&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports